import React, { useMemo } from "react";
import { useNoiseTexture, useStoneTexture } from "../hooks";
import { COLORS, QUAD_SIZE } from "../constants";

export default function Ground() {
  const grassTex = useNoiseTexture(256, COLORS.grass, COLORS.grassDark);
  const stoneTex = useStoneTexture();

  const stoneTexH = useMemo(() => {
    const t = stoneTex.clone();
    t.needsUpdate = true;
    t.repeat.set(20, 2.5);
    return t;
  }, [stoneTex]);
  const stoneTexV = useMemo(() => {
    const t = stoneTex.clone();
    t.needsUpdate = true;
    t.repeat.set(2.5, 20);
    return t;
  }, [stoneTex]);
  const stoneTexCenter = useMemo(() => {
    const t = stoneTex.clone();
    t.needsUpdate = true;
    t.repeat.set(4, 4);
    return t;
  }, [stoneTex]);

  return (
    <group>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]}>
        <planeGeometry args={[QUAD_SIZE * 2.4, QUAD_SIZE * 2.4, 1, 1]} />
        <meshStandardMaterial map={grassTex} color={COLORS.grass} roughness={1} />
      </mesh>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.02, 0]}>
        <planeGeometry args={[QUAD_SIZE * 2.2, 5]} />
        <meshStandardMaterial map={stoneTexH} roughness={0.85} />
      </mesh>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.02, 0]}>
        <planeGeometry args={[5, QUAD_SIZE * 2.2]} />
        <meshStandardMaterial map={stoneTexV} roughness={0.85} />
      </mesh>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.03, 0]}>
        <circleGeometry args={[10, 32]} />
        <meshStandardMaterial map={stoneTexCenter} roughness={0.85} />
      </mesh>
      <mesh receiveShadow rotation={[-Math.PI / 2, 0, 0]} position={[0, 0.025, 0]}>
        <ringGeometry args={[QUAD_SIZE * 0.85, QUAD_SIZE * 0.92, 64]} />
        <meshStandardMaterial map={stoneTexCenter} roughness={0.85} />
      </mesh>
    </group>
  );
}
